import { observer } from 'mobx-react-lite';
import cx from 'classnames';

import { ModalPortal } from '@popularKeyword/common-components';

import useStore from '@/hooks/useStore';

const InfoModal = () => {
  const { UIStore } = useStore();
  const { isShowInfoModal, setIsShowInfoModal } = UIStore;

  const onClickCloseButton = () => {
    setIsShowInfoModal(false);
  };

  if (!isShowInfoModal) return null;

  return (
    <ModalPortal>
      <div
        className={cx('c_modal c_modal_dimmed c_modal_keyword', isShowInfoModal && 'active')}
        id="arModal01"
        role="dialog"
        aria-modal="true"
        aria-hidden="true"
        aria-labelledby="aarModalInfoTitle"
      >
        <div className="modal_inner">
          <div className="modal_header">
            <h2 id="arModalInfoTitle" className="title">
              안내
            </h2>
          </div>
          <div className="modal_content">
            <div className="c-p-info">
              <h3 className="c-p-info__title">급상승 인기 키워드</h3>
              <ul className="c-p-info__list">
                <li className="c-p-info__list-item">기준일 전 주 11번가 실시간 쇼핑 검색어에 노출된 검색어입니다.</li>
              </ul>
              <h3 className="c-p-info__title">월간 인기 키워드</h3>
              <ul className="c-p-info__list">
                <li className="c-p-info__list-item">해당 월 고객이 많이 찾는 검색어입니다.</li>
              </ul>
              <h3 className="c-p-info__title">카테고리별 인기 키워드</h3>
              <ul className="c-p-info__list">
                <li className="c-p-info__list-item">해당 월 카테고리별 고객이 많이 찾는 검색어입니다.</li>
              </ul>
            </div>
          </div>
          <p className="modal_close">
            <button type="button" onClick={onClickCloseButton}>
              닫기
            </button>
          </p>
        </div>
      </div>
    </ModalPortal>
  );
};

export default observer(InfoModal);
